import { SharedModule } from '../../../shared/shared.module';
import { UserDetailsComponent } from './user-details.component';
import { UserDetailsResolver } from './user-details.resolver';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    NgbModule,
    DataTableModule,
    SharedModule
  ],
  declarations: [UserDetailsComponent],
  exports: [UserDetailsComponent],
  providers: [UserDetailsResolver],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})
export class UserDetailsModule {}
